module.exports = __webpack_public_path__ + "img/1-5.f6d78b50.svg";